// ── DnD ID Utilities ──
// Centralized ID generation and parsing for drag-and-drop operations

export const dndIds = {
  // ── ID generators ──
  sidebar: "sidebar",
  sidebarItem: (poiId: string) => `sidebar-${poiId}`,
  dayItem: (scheduledPoiId: string) => `scheduled-poi-${scheduledPoiId}`,
  noteItem: (noteId: string) => `note-${noteId}`,
  calendarPoiSegment: (scheduledPoiId: string, date: string) =>
    `scheduled-poi-${scheduledPoiId}@${date}`,
  calendarNoteSegment: (noteId: string, date: string) =>
    `note-${noteId}@${date}`,
  // Day columns are date-keyed — there are no day entities
  calendarDay: (date: string) => `calendar-day-${date}`,
  calendarDate: (date: string) => `calendar-date-${date}`,
  monthPoiSegment: (scheduledPoiId: string, date: string) =>
    `month-poi-${scheduledPoiId}@${date}`,
  monthNoteSegment: (noteId: string, date: string) =>
    `month-note-${noteId}@${date}`,
  weekAllDayNote: (noteId: string) => `week-all-day-note-${noteId}`,
  monthAllDayNoteSegment: (noteId: string, date: string) =>
    `month-all-day-note-${noteId}@${date}`,
  monthAccommodationSegment: (poiId: string, date: string) =>
    `month-accommodation-${poiId}@${date}`,
  legRange: (legId: string) => `leg-range-${legId}`,
  // The leg band needs its own date drop surface: it renders alongside the
  // all-day note rail, and two droppables sharing an id would overwrite each
  // other in dnd-kit's container map.
  legBandDate: (date: string) => `leg-band-date-${date}`,
  legDropTarget: (legId: string) => `leg-drop-${legId}`,
  monthLegSegment: (legId: string, date: string) =>
    `month-leg-${legId}@${date}`,

  // ── Parsers ──
  parseDayItem: (id: string): string => id.replace("scheduled-poi-", ""),

  parseSidebarItem: (id: string): string => id.replace("sidebar-", ""),

  parseNoteItem: (id: string): string => id.replace("note-", ""),

  parseCalendarDay: (id: string): string => id.replace("calendar-day-", ""),

  // ── Type guards ──
  isDayItem: (id: string): boolean => id.startsWith("scheduled-poi-"),
  isSidebarItem: (id: string): boolean => id.startsWith("sidebar-"),
  isNoteItem: (id: string): boolean => id.startsWith("note-"),
  isCalendarDay: (id: string): boolean => id.startsWith("calendar-day-"),
  isLegDropTarget: (id: string): boolean => id.startsWith("leg-drop-"),
  parseLegDropTarget: (id: string): string => id.replace("leg-drop-", ""),
};
